import React from 'react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

function SearchBar({
  value,
  onChange,
  placeholder = 'Search row tabs...',
}: SearchBarProps) {
  return (
    <div className="pq-search-bar">
      <span className="pq-search-icon">&#128269;</span>
      <input
        type="text"
        className="pq-search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
      />
      {value && (
        <button className="pq-search-clear" onClick={() => onChange('')}>
          &times;
        </button>
      )}
    </div>
  );
}

export default SearchBar;
